import { useEffect, useCallback } from "react";
import { useCartData } from "@/zustand/cartStore";
import { useProductData } from "@/zustand/productStore";

export const useAxonTracking = () => {
  const { selectedProduct } = useCartData();
  const { currency_code } = useProductData();

  const fireEvent = useCallback(
    (eventName, extraData = {}) => {
      if (!window.axon || !selectedProduct) return;

      const qty = parseInt(selectedProduct.amount) || 1;
      const unitPrice = parseFloat(selectedProduct.price) || 0;
      const totalValue = unitPrice * qty;
      const itemImage =
        selectedProduct.image?.url || selectedProduct.image || null;

      const payload = {
        currency: currency_code || "USD",
        value: totalValue,
        shipping: parseFloat(selectedProduct.shipping_price) || 0,
        tax: 0,
        affiliation: window.affiliate || null,
        items: [
          {
            item_id:
              selectedProduct.konnektive_id || selectedProduct.sku || "unknown",
            item_name: selectedProduct.display_name || "Product",
            price: unitPrice,
            quantity: qty,
            item_category: "Home & Garden",
            image_url: itemImage,
          },
        ],
        ...extraData,
      };

      window.axon("track", eventName, payload);
    },
    [selectedProduct, currency_code],
  );

  useEffect(() => {
    if (selectedProduct?.sku || selectedProduct?.konnektive_id) {
      fireEvent("begin_checkout");
    }
  }, [selectedProduct?.sku, selectedProduct?.konnektive_id, fireEvent]);

  const trackPurchase = (orderId, formData) => {
    if (!window.axon || !selectedProduct) return;

    const userData = {
      email: formData?.email || null,
      phone: formData?.phone || null,
      first_name: formData?.first_name || null,
      last_name: formData?.last_name || null,
      address: formData?.address || null,
      city: formData?.city || null,
      state: formData?.state || null,
      zip: formData?.zip || null,
      country: formData?.country || null,
    };

    fireEvent("purchase", {
      transaction_id: orderId,
      user_data: userData,
    });
  };

  return { trackPurchase };
};
